import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-hdr" }
const _hoisted_3 = { class: "card-tools" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "card-body mini-map"
}
const _hoisted_7 = {
  key: 0,
  class: "address-box"
}
const _hoisted_8 = { class: "addr-text" }
const _hoisted_9 = {
  key: 1,
  class: "no-loc"
}
const _hoisted_10 = {
  key: 1,
  class: "card-body"
}

import Placeholder from "@/components/ui/Placeholder.vue";
import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";
import { computed, nextTick, ref, watch } from "vue";
import { useToast } from "vue-toast-notification";

const initialZoom = 12;

export default /*@__PURE__*/_defineComponent({
  ...{ name: "LocationCard" },
  __name: 'LocationCard',
  props: {
    isEnabled: { type: Boolean },
    deviceName: {},
    location: {},
    address: {}
  },
  emits: ["refresh", "center", "open-modal"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const toast = useToast();
const defaultCenter: [number, number] = [45.41, 11.88];
const hasLocation = computed(
  () => Array.isArray(props.location) && props.location.length === 2
);

// Riferimento alla mappa
const mapRef = ref<InstanceType<typeof LMap>>();

// Funzione per centrare immediatamente sulla posizione del device
const handleCenterClick = () => {
  if (!hasLocation.value || !mapRef.value?.leafletObject)
    return toast.success(
      `Impossibile centrare la mappa sulla posizione del dispositivo per mancanza di coordinate, imposta prima la modalità a 'Dinamico'`,
      { duration: 2500 }
    );

  const map = mapRef.value.leafletObject;

  // Centra immediatamente sul marker con zoom ottimale
  map.setView(props.location!, 14, {
    animate: true,
    duration: 0.5, // Durata più breve per un effetto più immediato
    easeLinearity: 0.25,
  });

  // Emetti l'evento al componente padre
  emit("center");
};

// Quando la posizione cambia, aggiorna automaticamente il centro della mappa
watch(
  () => props.location,
  (newLocation) => {
    if (newLocation && hasLocation.value && mapRef.value?.leafletObject) {
      const map = mapRef.value.leafletObject;
      // Aggiorna il centro ma mantieni lo zoom corrente
      map.setView(newLocation, map.getZoom(), {
        animate: false, // Senza animazione per aggiornamenti automatici
      });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Current Location", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "ico-btn-card",
          title: "Refresh",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh')))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M17.65 6.35A7.95 7.95 0 0 0 12 4V1L7 6l5 5V7c2.76 0 5 2.24 5 5a5 5 0 0 1-8.66 3.54l-1.42 1.42A7 7 0 1 0 19 12c0-1.93-.78-3.68-2.05-4.95z"
            })
          ], -1)
        ]))]),
        _createElementVNode("button", {
          class: "ico-btn-card",
          disabled: !__props.isEnabled || !hasLocation.value,
          title: "Centra",
          onClick: handleCenterClick
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M12 8a4 4 0 1 1 0 8a4 4 0 0 1 0-8m9 3h-2.05a7 7 0 0 0-5.95-5.95V3h-2v2.05A7 7 0 0 0 5.05 11H3v2h2.05A7 7 0 0 0 11 18.95V21h2v-2.05A7 7 0 0 0 18.95 13H21z"
            })
          ], -1)
        ]))], 8, _hoisted_4),
        _createElementVNode("button", {
          class: "ico-btn-card",
          disabled: !__props.isEnabled,
          title: "Dettagli",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open-modal')))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M11 7h2v2h-2zm0 4h2v6h-2z"
            }),
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8a8.01 8.01 0 0 1-8 8"
            })
          ], -1)
        ]))], 8, _hoisted_5)
      ])
    ]),
    (__props.isEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(LMap), {
            ref_key: "mapRef",
            ref: mapRef,
            zoom: initialZoom,
            center: hasLocation.value ? (__props.location as any) : defaultCenter,
            options: {
          zoomControl: false,
          attributionControl: false,
          scrollWheelZoom: false,
          dragging: true,
        },
            style: {"height":"220px","width":"100%","border-radius":"8px","overflow":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LTileLayer), { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
              (hasLocation.value)
                ? (_openBlock(), _createBlock(_unref(LMarker), {
                    key: 0,
                    "lat-lng": __props.location!
                  }, null, 8, ["lat-lng"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["center"]),
          (__props.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "addr-icon" }, "📍", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(__props.address), 1)
              ]))
            : _createCommentVNode("", true),
          (!hasLocation.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(Placeholder, { label: "Posizione non disponibile per questo device" })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(Placeholder, { label: `Nessun dato in ${'modulo'}` })
        ]))
  ]))
}
}

})